import { ForwardedRef, KeyboardEvent, forwardRef } from 'react';
import { z } from 'zod';

import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
  InputGroupText,
} from '@eluve/components';
import { useForwardedRef } from '@eluve/utility-hooks';

export type CurrencyInputProps = {
  onBlur?: () => void;
  onChange: (newValue: string) => void;
  ref: ForwardedRef<HTMLInputElement>;
  value?: string;
};

export const currencyStringToCentsSchema = z
  .string()
  .refine((p) => !isNaN(parseFloat(p)))
  .transform((p) => Math.floor(Number(p) * 100));

export const CurrencyInput = forwardRef<HTMLInputElement, CurrencyInputProps>(
  ({ onBlur, onChange, value }, ref) => {
    const inputRef = useForwardedRef(ref);

    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Escape') {
        inputRef.current?.blur();
      }
    };

    return (
      <InputGroup>
        <InputGroupAddon align="inline-start">
          <InputGroupText>$</InputGroupText>
        </InputGroupAddon>
        <InputGroupInput
          className="[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
          onBlur={onBlur}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="0.00"
          ref={inputRef}
          required
          min={0.0}
          step={0.01}
          type="number"
          value={value ?? ''}
        />
      </InputGroup>
    );
  },
);
